import React from 'react';
import { Badge, Box, Group } from '@mantine/core';
import type { EntityRegistryEntry } from '../types';

export const contentConfig: EntityRegistryEntry = {
    fetchAttributes: ['Id', 'DisplayName', 'EntityType', 'Subject', 'Tags', 'ContentType'],
    listColumns: () => [
        {
            key: 'subject',
            label: 'Subject',
            sortable: true,
            render: (entity: any) => entity.Subject || entity.subject || 'N/A'
        },
        {
            key: 'tags',
            label: 'Tags',
            sortable: false,
            render: (entity: any) => {
                let tags = entity.Tags || entity.tags;

                if (typeof tags === 'string' && tags.trim().startsWith('[')) {
                    try {
                        tags = JSON.parse(tags);
                    } catch (e) {
                        tags = tags ? [tags] : [];
                    }
                }

                if (Array.isArray(tags) && tags.length > 0) {
                    return (
                        <Group gap={4} wrap="wrap">
                            {tags.map((tag: any, index: number) => (
                                <Badge
                                    key={index}
                                    variant="outline"
                                    size="sm"
                                >
                                    {typeof tag === 'string' ? tag : (tag.DisplayName || tag.displayName || String(tag))}
                                </Badge>
                            ))}
                        </Group>
                    );
                }
                return 'N/A';
            }
        }
    ]
};
